import React from 'react';
import { Select } from 'antd';
import { useIntl } from 'react-intl';
import { FilterOutlined } from '@ant-design/icons';
import { Category } from 'utils/apiClient/services/inventory/types';

const { Option } = Select;

export interface SalesFilterProps {
  handleCategoriesFilterChange: (values: number[]) => void;
  categories: Array<Category>;
}

const SalesFilter: React.FC<SalesFilterProps> = ({
  handleCategoriesFilterChange,
  categories,
}) => {
  const intl = useIntl();

  return (
    <Select
      mode="multiple"
      placeholder={intl.formatMessage({ defaultMessage: 'Filter by Category' })}
      dropdownStyle={{ minWidth: 200 }}
      style={{ minWidth: 200 }}
      popupMatchSelectWidth={false}
      suffixIcon={<FilterOutlined />}
      onChange={handleCategoriesFilterChange}
    >
      {categories.map(({ id, name }) => (
        <Option key={id} value={id}>
          {name}
        </Option>
      ))}
    </Select>
  );
};

export default SalesFilter;
